var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0065 0.557251C11.0612 0.557251 10.2918 1.21599 10.2918 2.02549C10.2918 2.83786 11.0612 3.49373 12.0065 3.49373C12.9553 3.49373 13.7213 2.83771 13.7213 2.02549C13.7213 1.21599 12.9551 0.557251 12.0065 0.557251ZM0 10.838C0 11.6504 0.769319 12.3063 1.71471 12.3063C2.66344 12.3063 3.42941 11.6502 3.42941 10.838C3.42941 10.0285 2.66327 9.36978 1.71471 9.36978C0.769319 9.36978 0 10.0285 0 10.838ZM20.4987 3.56915C21.1671 4.14142 21.1671 5.07095 20.4987 5.64594C19.8272 6.21821 18.7416 6.21821 18.0701 5.64594C17.4018 5.07095 17.4018 4.14139 18.0701 3.56915C18.7416 2.99416 19.8272 2.99416 20.4987 3.56915ZM5.94296 16.0302C6.61129 16.6052 6.61129 17.5347 5.94296 18.1097C5.27145 18.682 4.18584 18.682 3.51755 18.1097C2.84604 17.5347 2.84604 16.6052 3.51755 16.0302C4.18588 15.4579 5.27145 15.4579 5.94296 16.0302ZM3.51755 3.56915C2.84604 4.14142 2.84604 5.07095 3.51755 5.64594C4.18588 6.21821 5.27145 6.21821 5.94296 5.64594C6.61129 5.07095 6.61129 4.14139 5.94296 3.56915C5.27145 2.99416 4.18584 2.99416 3.51755 3.56915ZM12.0066 18.1822C11.0612 18.1822 10.2919 18.8409 10.2919 19.6504C10.2919 20.4628 11.0612 21.1186 12.0066 21.1186C12.9553 21.1186 13.7213 20.4626 13.7213 19.6504C13.7213 18.8409 12.9552 18.1822 12.0066 18.1822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.6adb9eefa4b411aa74a5ca65fbac6ad0.svg";
export { ForwardRef as ReactComponent };